var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "rb-pay-over-time" },
        [
          _vm.canShowSkeletonInCart
            ? _c("div", { staticClass: "skeleton block-skeleton" }, [_vm._m(0)])
            : _c(
                "button",
                {
                  staticClass: "rb-pay-over-time__button",
                  on: { click: _vm.openPayOverTimeModalOrPanel },
                },
                [
                  _c("rb-pay-over-time-panel-and-modal", {
                    attrs: { visible: _vm.visible },
                    on: { closed: _vm.closePayOverTimeModalOrPanel },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "rb-pay-over-time__message" }, [
                    _vm._v(_vm._s(_vm.$t("pay_over_time.message"))),
                  ]),
                  _vm._v(" "),
                  _vm.paypalVisible
                    ? _c(
                        "span",
                        { staticClass: "common__icon common__icon--paypal" },
                        [_vm._v(_vm._s(_vm.paypal))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.payPalSeparator
                    ? _c("span", [_vm._v(" " + _vm._s(_vm.payPalSeparator))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.klarnaVisible
                    ? _c(
                        "span",
                        {
                          staticClass: "common__icon common__icon--klarna-logo",
                        },
                        [_vm._v(_vm._s(_vm.klarna))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.klarnaSeparator
                    ? _c("span", [
                        _vm._v(" " + _vm._s(_vm.klarnaSeparator) + " "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.afterpayVisible
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "common__icon common__icon--afterpay-logo",
                        },
                        [_vm._v(_vm._s(_vm.afterpay))]
                      )
                    : _vm._e(),
                ],
                1
              ),
          _vm._v(" "),
          !_vm.isPdp
            ? _c("modal-portal", {
                staticClass: "modal-wrapper--pay-over-time",
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dummy-block" }, [
      _c("div", { staticClass: "skeleton skeleton-copy-container" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }